import {
  Button,
  Card,
  Carousel,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  Grid,
  Input,
  Popover,
  Row,
  Tabs,
  theme,
  Typography,
  Image,
  List,
  Rate,
  Dropdown,
  Space,
  MenuProps,
  Avatar,
  Badge,
  message,
  Segmented,
  Collapse,
  Slider,
  SliderSingleProps,
} from "antd";
import destinations3 from "assets/images/destinations3.jpg";
import destinations6 from "assets/images/destinations6.jpg";
import cat1 from "assets/images/cat1.png";
import "../../product-component/productComponent.scss";
import React from "react";

const { Panel } = Collapse;

const currency: MenuProps["items"] = [
  {
    label: (
      <a
        href="https://www.antgroup.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        1st menu item
      </a>
    ),
    key: "0",
  },
  {
    label: (
      <a
        href="https://www.aliyun.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        2nd menu item
      </a>
    ),
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: "3rd menu item",
    key: "3",
  },
];

const marks: SliderSingleProps["marks"] = {
  0: { label: <small>AED15.00</small> },
  100: {
    label: <small>AED8,398.80</small>,
  },
};

const data = ["Instant Confirmation", "Non Refundable"];

function RightPenalComponent() {
  const [priceValue, setPriceValue] = React.useState([0, 100]);
  return (
    <>
      <div>
        <Collapse defaultActiveKey={1} className="eff-collapse mb-3">
          <Panel header="Tour Category" key="1">
            <List>
              <List.Item>
                <Checkbox checked className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Sightseeing Tours
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Culture and Attractions
                </Checkbox>
              </List.Item>
            </List>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={1} className="eff-collapse mb-3">
          <Panel header="Price" key="1">
            <Slider
              range={{}}
              value={priceValue}
              onChange={setPriceValue}
              marks={marks}
              className="priceSlider"
            />
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={1} className="eff-collapse mb-3">
          <Panel header="Best Deals" key="1">
            <List>
              <List.Item>
                <Checkbox checked className="checkbox-danger">
                  Super Saver Deals
                </Checkbox>
              </List.Item>
              <List.Item>
                <Checkbox className="checkbox-danger">
                  Discounted Deals
                </Checkbox>
              </List.Item>
            </List>
          </Panel>
        </Collapse>
      </div>
    </>
  );
}

export default RightPenalComponent;
